import { RobotOutlined } from '@ant-design/icons'
import { Button } from 'aa_common/front-end/antd'
import { If } from 'aa_common/front-end/components'
import { Col, Row, Typography } from 'antd'
import { getNs } from 'common/i18n-config'

import { useAISelectSuggestion } from '../hooks/use-ai-select-suggestion'
import { Card, CardIcon } from '../styles'
import { Suggestion } from '../types'
import { AICardContent } from './ai-card-content'
import { AIDisclaimer } from './ai-disclaimer'
import { AIMultipleSuggestionNotice } from './ai-multiple-suggestion-notice'

const { Text, Title } = Typography

const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])

type AISubmittedResultProps = {
  suggestions?: Suggestion[]
  imageSrc?: string
  onTryAgain?: () => void
  onReflect?: (suggestion?: Suggestion) => void
  isRegisteredCategory?: (suggestion?: Suggestion) => boolean
}

export const AISubmittedResult = ({
  suggestions,
  imageSrc,
  onTryAgain,
  onReflect,
  isRegisteredCategory,
}: AISubmittedResultProps) => {
  useNsReady()
  const { selectedSuggestion, setSelectedSuggestion } = useAISelectSuggestion()

  const hasSingleSuggestion = suggestions && suggestions.length === 1
  const effectiveSelected = hasSingleSuggestion ? suggestions[0] : selectedSuggestion

  return (
    <Card>
      <Row align="middle" justify="space-between" style={{ marginBottom: '24px' }}>
        <Col span={24}>
          <Row align="middle" gutter={12}>
            <Col span={3}>
              <CardIcon>
                <RobotOutlined style={{ fontSize: '16px', color: 'white' }} />
              </CardIcon>
            </Col>
            <Col span={21}>
              <div>
                <Title level={5}>{t('ai_estimated_categories')}</Title>
                <Text type="secondary" style={{ fontSize: '14px' }}>
                  {t('ai_estimated_categories_description')}
                </Text>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <If condition={suggestions && suggestions.length > 1}>
        <AIMultipleSuggestionNotice />
      </If>

      {suggestions?.map(item => (
        <AICardContent
          key={item.asset_category_code}
          data={item}
          imageSrc={imageSrc}
          selected={
            suggestions?.length > 1 &&
            effectiveSelected?.asset_category_code === item.asset_category_code &&
            !item.is_proposed_new_category
          }
          onClick={() => setSelectedSuggestion(item)}
          isRegisteredCategory={isRegisteredCategory?.(item)}
        />
      ))}

      {suggestions && suggestions.length > 0 && (
        <Row gutter={16} style={{ marginTop: 24 }}>
          <Col span={12}>
            <Button
              block
              disabled={!effectiveSelected || effectiveSelected?.is_proposed_new_category}
              onClick={() => onReflect?.(effectiveSelected)}
            >
              {t('reflect_to_form')}
            </Button>
          </Col>
          <Col span={12}>
            <Button color="grey" block onClick={onTryAgain}>
              {t('try_again')}
            </Button>
          </Col>
        </Row>
      )}

      <AIDisclaimer className="disclaimer" />
    </Card>
  )
}
